// =============================================================================
// HidroVerse content — split from the legacy /lib/content.js.
// Imports continue to work from '../lib/content' via the barrel re-export.
// Edit copy here; do NOT touch the barrel in /lib/content.js.
// =============================================================================

// ==============================================================================
// HidroVerse — SEO-enriched content layer.
// Includes: industry FAQs, solution specs, expert guides (long-form), page meta.
// ==============================================================================

export const BRAND = {
  name: "HidroVerse",
  tagline: "Universal Water Systems",
  domain: "hidroverse.co.za",
  quote: "Water is the driving force of all life.",
  attribution: "Leonardo da Vinci",
  promise: "We bridge the gap between humanity and water.",
  mission:
    "Turning complex water challenges into sustainable, high-performance systems — through technical mastery, innovation, and a commitment to long-term partnerships.",
  vision:
    "To set the benchmark for intelligent, engineered water systems across Africa and beyond — delivering reliability, purity, and sustainability for every client we serve.",
  values: [
    ["Excellence", "We uphold the highest standards in every design, installation and service — because water systems must never fail."],
    ["Expertise", "Our in-house specialists and network of professional partners bring multi-disciplinary knowledge to every project."],
    ["Innovation", "We pioneer smarter, more efficient solutions — adapting to new technologies and evolving client needs."],
    ["Integrity", "We act with honesty, transparency and accountability, from consultation to long-term support."],
    ["Partnership", "We work collaboratively with architects, engineers, developers, lodges, hotels and communities — building trust and long-lasting relationships."],
    ["Reliability", "We provide systems designed for real-world conditions, ensuring consistent performance and peace of mind."],
    ["Customer First", "Every decision is guided by the success, safety and satisfaction of our clients and their guests."],
  ],
  phone: "+27 72 320 7326",
  phoneIntl: "+27723207326",
  whatsapp: "27723207326",
  email: "nelspruit@hidroverse.co.za",
  address: "Nelspruit, Mpumalanga, South Africa",
  // Social profiles — append to BRAND.social, do not edit BRAND.phone above.
  social: {
    linkedin: "https://www.linkedin.com/company/hidroverse/",
    instagram: "https://www.instagram.com/hidroverse",
    facebook: "https://www.facebook.com/share/17cPoy9NUN/",
  },
  // Full Name-Address-Phone block for LocalBusiness schema, Footer NAP and Contact page.
  nap: {
    street: "Waterfall Park, Unit C1, Waterfall Avenue",
    locality: "Nelspruit",
    region: "Mpumalanga",
    postal: "1200",
    country: "South Africa",
    countryCode: "ZA",
    lat: -25.4753,
    lng: 30.9694,
    hours: [
      ["Mon – Fri", "08:00 – 17:00"],
      ["Sat – Sun", "On-call only"],
    ],
    // Schema.org openingHours specification
    openingHoursSpec: [
      { day: ["Monday","Tuesday","Wednesday","Thursday","Friday"], opens: "08:00", closes: "17:00" },
    ],
    // Geographic area we actually serve.
    areaServed: ["Mpumalanga", "Limpopo", "Gauteng", "KwaZulu-Natal", "Eastern Cape", "Western Cape", "South Africa"],
  },
};

export const APP_URLS = {
  signIn: "https://tech-dispatch-55.emergent.host/login",
  salesFloor: "https://logic-explainer-2.emergent.host/",
  site: "https://hidroverse.co.za",
};

// ==============================================================================
// REFERENCE INSTALLS — named reference projects with hard numbers
// ==============================================================================

export const INSTALLS = [
  { name: "Kruger Park Lodge", location: "Hazyview · Legacy Hotel Group", stat: "320 keys", lbl: "Hospitality install", img: "/mockups/ind_hotels_ops.webp" },
  { name: "MalaMala Game Reserve", location: "Sabi Sand · Private Reserve", stat: "Multi-camp", lbl: "Lodge install", img: "/mockups/ind_lodges_hero.png" },
  { name: "Karingani Game Reserve", location: "Mozambique · Cross-border", stat: "150,000 ha", lbl: "Wildlife install", img: "/mockups/ind_lodges_ops.webp" },
  { name: "Leopard Creek", location: "Malelane · Championship golf", stat: "18 holes", lbl: "Estate install", img: "/mockups/ind_estates_hero.png" },
  { name: "Active Mining Operation", location: "Limpopo · NDA", stat: "Section 54", lbl: "Mining install", img: "/mockups/ind_mines_hero.png" },
  { name: "Citrus Estate", location: "Onderberg · Commercial farm", stat: "1,200 ha drip", lbl: "Agricultural install", img: "/mockups/ind_agri_hero.png" },
];

export const STANDARDS_BADGES = [
  "SANS 241", "SANS 10090", "PIRB Registered", "ECSA Affiliated", "WISA Member", "Blue Drop", "Green Drop", "WHO Guidelines",
];
